import React, { Component } from 'react';
import Select, { components } from 'react-select';
import { FaEdit, FaBars, FaTrash, FaCheck, FaTimes, FaEye, FaMusic, FaSync } from 'react-icons/fa';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { HotKeys } from 'react-hotkeys';
import { Switch } from 'pretty-checkbox-react';

import Header from 'components/Header';

import customStyles from 'consts/CustomStyles';

import { syncDropboxSounds } from 'redux/actions';

class Test extends Component {

    constructor(props) {
        super(props);
    
        this.state = {
          isEditing: false
        };
    
        this.keyMap = {
          TEST: "Control+p"
        };
    
        this.handlers = {
          TEST: () => this.test()
        };
    }

    test = () => {
        console.log('SHORT');
    }

    render() {
        const options = [
            { value: '1', label: '1: Chocolate' },
            { value: '2', label: '2: Strawberry' },
            { value: '3', label: '3: Vanilla' }
        ];

        return (
            <HotKeys keyMap={this.keyMap} handlers={this.handlers} >
                <section id="main">
                    <section id="la-soundbox-container">
                
                        <Header />
                        
                        <div>
                            <FaSync onClick={() => {this.props.syncDropboxSounds()}}/>
                        </div>

                        <h2>Home-Text</h2>
                        <div className={'soundbox-grid-bar-container home-text'}>
                            <NavLink className={'soundbox-grid-bar'} to={'/'}>
                                <div className={'soundbox-grid-bar-title'}>
                                    <span>Liste des bundles</span>
                                </div>
                            </NavLink>
                        </div>

                        <h2>Bundle-list</h2>
                        <div className={'soundbox-grid-bar-container bundles-list'}>
                            <form className={'soundbox-grid-bar'}>
                                <div className={'soundbox-grid-bar-handle'}>
                                    <FaBars />
                                </div>
                                <div className={'soundbox-grid-bar-id'}> 
                                    <input type="number" name="form-id" required ref={input => this.id = input} />
                                </div>
                                <div className={'soundbox-grid-bar-title'}>
                                    <input type="text" name="form-title" required ref={input => this.title = input} />
                                </div>
                                <div className={'soundbox-grid-bar-active'}>
                                    <Switch shape={'fill'} color={'danger'} ref={input => this.active = input}>{'\u00A0'}</Switch>
                                </div>
                                <button type="submit" className={'soundbox-grid-bar-save'}>
                                    <FaCheck />
                                </button>
                                <div className={'soundbox-grid-bar-cancel'} onClick={() => {}}>
                                    <FaTimes />
                                </div>
                            </form>
                            <div className={'soundbox-grid-bar'}>
                                <div className={'soundbox-grid-bar-handle'}><FaBars /></div>
                                <div className={'soundbox-grid-bar-id'}>
                                    <span>ID</span>
                                </div>
                                <div className={'soundbox-grid-bar-title'}>
                                    <span>TITRE</span>
                                </div>
                                <div className={'soundbox-grid-bar-active'}>
                                    <Switch shape={'fill'} locked={true} color={'danger'} checked={true} onChange={() => {}}></Switch>
                                </div>
                                <NavLink className={'soundbox-grid-bar-edit'} to={'/'}><FaEdit /></NavLink>
                                <div className={'soundbox-grid-bar-delete'} onClick={() => {}}><FaTrash /></div>
                            </div>
                        </div>

                        <h2>Soundbox-list</h2>
                        <div className={'soundbox-grid-bar-container soundboxs-list'}>
                            <div className={'soundbox-grid-bar'}>
                                <div className={'soundbox-grid-bar-id'}>
                                    <span>ID</span>
                                </div>
                                <div className={'soundbox-grid-bar-title'}>
                                    <span>TITRE</span>
                                </div>
                                <div className={'soundbox-grid-bar-count'}>
                                    <span>200</span>
                                </div>
                                <NavLink className={'soundbox-grid-bar-see'} to={'/'}><FaEye /></NavLink>
                            </div>
                        </div>

                        <h2>Movie-list</h2>
                        <div className={'soundbox-grid-bar-container movie-list'}>
                            <form className={'soundbox-grid-bar'}>
                                <div className={'soundbox-grid-bar-id'}> 
                                    <input type="number" name="form-id" required ref={input => this.id = input} />
                                </div>
                                <div className={'soundbox-grid-bar-title'}>
                                    <input type="text" name="form-title" required ref={input => this.title = input} />
                                </div>
                                <button type="submit" className={'soundbox-grid-bar-save'}>
                                    <FaCheck />
                                </button>
                                <div className={'soundbox-grid-bar-cancel'} onClick={() => {}}>
                                    <FaTimes />
                                </div>
                            </form>
                            <div className={'soundbox-grid-bar'}>
                                <div className={'soundbox-grid-bar-id'}>
                                    <span>ID</span>
                                </div>
                                <div className={'soundbox-grid-bar-title'}>
                                    <span>TITRE</span>
                                </div>
                                <NavLink className={'soundbox-grid-bar-edit'} to={'/'}><FaEdit /></NavLink>
                                <div className={'soundbox-grid-bar-delete'} onClick={() => {}}><FaTrash /></div>
                            </div>
                        </div>

                        <h2>Character-list</h2>
                        <div className={'soundbox-grid-bar-container character-list'}>
                            <form className={'soundbox-grid-bar'}>
                                <div className={'soundbox-grid-bar-id'}> 
                                    <input type="number" name="form-id" required ref={input => this.id = input} />
                                </div>
                                <div className={'soundbox-grid-bar-title'}>
                                    <input type="text" name="form-title" required ref={input => this.title = input} />
                                </div>
                                <button type="submit" className={'soundbox-grid-bar-save'}>
                                    <FaCheck />
                                </button>
                                <div className={'soundbox-grid-bar-cancel'} onClick={() => {}}>
                                    <FaTimes />
                                </div>
                            </form>
                            <div className={'soundbox-grid-bar'}>
                                <div className={'soundbox-grid-bar-id'}>
                                    <span>ID</span>
                                </div>
                                <div className={'soundbox-grid-bar-title'}>
                                    <span>TITRE</span>
                                </div>
                                <NavLink className={'soundbox-grid-bar-edit'} to={'/'}><FaEdit /></NavLink>
                                <div className={'soundbox-grid-bar-delete'} onClick={() => {}}><FaTrash /></div>
                            </div>
                        </div>

                        <h2>Sound-list</h2>
                        <div className={'soundbox-grid-sound-container'}>
                            <div className={'soundbox-grid-sound'}>
                                <div className={'soundbox-grid-sound-id'}>
                                    <img src={undefined} alt={''} title={''} />
                                    <span>#1</span>
                                </div>
                                <div className={'soundbox-grid-sound-movie'}>
                                    <span>1</span>
                                </div>
                                <div className={'soundbox-grid-sound-characters'}>
                                    <span>1, 2</span>
                                </div>
                                <div className={'soundbox-grid-sound-timing'}>
                                    <span>1h12m</span>
                                </div>
                                <div className={'soundbox-grid-sound-title'}>
                                    Title un peu trop long !!!
                                </div>
                                <div className={'soundbox-grid-sound-play'}><FaMusic/></div>
                                <div className={'soundbox-grid-sound-quote'}>
                                    <textarea ref={input => this.quote = input} defaultValue="Bonjour" readOnly></textarea>
                                </div>
                                <NavLink className={'soundbox-grid-sound-edit'} to={'/'}><FaEdit /></NavLink>
                                <div className={'soundbox-grid-sound-delete'} onClick={() => {}}><FaTrash /></div>
                            </div>
                            <form className={'soundbox-grid-sound'}>
                                <div className={'soundbox-grid-sound-id'}>
                                    <input type="number" name="form-id" placeholder="ID" required ref={input => this.id = input} />
                                </div>
                                <div className={'soundbox-grid-sound-movie'}>
                                    <Select 
                                        ref={'movie'} 
                                        options={options} 
                                        styles={customStyles.movies}
                                        placeholder={'Film'}
                                        components={{ 
                                            SingleValue:({ ...props }) => { return <components.SingleValue {...props}>{props.getValue()[0].value}</components.SingleValue>},
                                            IndicatorsContainer:() => { return null }
                                        }}>
                                    </Select>
                                </div>
                                <div className={'soundbox-grid-sound-characters'}> 
                                    <Select 
                                        ref={'characters'} 
                                        isMulti
                                        closeMenuOnSelect={false}
                                        options={options} 
                                        styles={customStyles.chars}
                                        placeholder={'Chars'}
                                        components={{ 
                                            MultiValueLabel:({ ...props }) => { return (<components.MultiValueLabel {...props}>{props.data.value}</components.MultiValueLabel>)},
                                            IndicatorsContainer:() => { return null }
                                        }}>
                                    </Select>
                                </div>
                                <div className={'soundbox-grid-sound-timing'}>
                                    <input type="text" name="form-timing" placeholder="Temps" required ref={input => this.timing = input} />
                                </div>
                                <div className={'soundbox-grid-sound-title'}>
                                    <input type="text" name="form-title" placeholder="Titre" required ref={input => this.title = input} />
                                </div>
                                <div className={'soundbox-grid-sound-play'}><FaMusic/></div>
                                <div className={'soundbox-grid-sound-quote'}>
                                    <textarea ref={input => this.quote = input} placeholder="Réplique" defaultValue=""></textarea>
                                </div>
                                <NavLink className={'soundbox-grid-sound-save'} to={'/'}>
                                    <FaCheck />
                                </NavLink>
                                <div className={'soundbox-grid-sound-cancel'} onClick={() => {}}>
                                    <FaTimes />
                                </div>
                            </form>
                        </div>
                    </section>
                </section>
            </HotKeys>
        )
    }
}

const mapStateToProps = (state) => {
    return (state);
};

const mapDispatchToProps = { syncDropboxSounds };

export default connect(mapStateToProps, mapDispatchToProps)(Test);
